<vex-page-layout mode="card">

    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.container]="layoutCtrl.value === 'boxed'"
             [class.px-gutter]="layoutCtrl.value === 'fullwidth'"
             class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">{{ "MENUS.PROYECTOS" | translate }}</h1>
                <vex-breadcrumbs
                    [crumbs]="['MENUS.ADMINISTRACION', 'MENUS.PROYECTOS']"></vex-breadcrumbs>
            </div>

        </div>
    </vex-page-layout-header>

    <vex-page-layout-content class="-mt-6">

        <div>
            <form [formGroup]="searchForm">
                <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">

                    <div
                        class="bg-foreground rounded-full px-4 h-10 max-w-[400px] flex-auto flex items-center border border-gray-300">
                        <mat-icon class="icon-sm text-secondary" svgIcon="mat:person"></mat-icon>
                        <input formControlName="user"
                               class="px-4 py-2 border-0 outline-none w-full bg-transparent"
                               [placeholder]="'ACTIONS.BUSCAR_PROYECTOS' | translate"
                               type="search">
                    </div>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        [matTooltip]="'ACTIONS.BUSCAR_PROYECTOS' | translate "
                        type="button"
                        (click)="buscar()">
                        <mat-icon svgIcon="mat:search"></mat-icon>
                    </button>

                    <span class="flex-1"></span>
                    
                    <button
                            class="ml-4 flex-none"
                            color="warn"
                            mat-mini-fab
                            [matTooltip]="'ACTIONS.RECHAZAR_FORZAR_COMENTARIOS' | translate "
                            type="button"
                            (click)="rechazarSelected()">
                        <mat-icon svgIcon="mat:clear"></mat-icon>
                    </button>

                    <button
                            class="ml-4 flex-none"
                            color="primary"
                            mat-mini-fab
                            [matTooltip]="'ACTIONS.FORZAR_COMENTARIOS' | translate "
                            type="button"
                            (click)="aprobarSelected()">
                        <mat-icon svgIcon="mat:check"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        [matTooltip]="'ACTIONS.AGREGAR_PROYECTO' | translate "
                        (click)="createProject()"
                        type="button">
                        <mat-icon svgIcon="mat:add"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        [matTooltip]="'ACTIONS.EXPORTAR' | translate "
                        type="button"
                        (click)="export()">
                        <mat-icon svgIcon="mat:cloud_download"></mat-icon>
                    </button>

                </div>
            </form>

            <table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort>
                <!-- Text Columns -->
                <ng-container *ngFor="let column of columns; trackBy: trackByProperty">
                    <ng-container *ngIf="column.type === 'badge'"  [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell
                            mat-sort-header>
                            <mat-checkbox (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                [disabled]="notSelection"
                                color="primary">
                                {{ column.label | translate }}
                            </mat-checkbox>
                        </th>
                        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
                            <mat-checkbox (click)="$event.stopPropagation()"
                                          (change)="$event ? selection.toggle(row) : null"
                                          [checked]="selection.isSelected(row)"
                                          color="primary">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container *ngIf="column.type === 'text'"  [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell
                            mat-sort-header> {{ column.label | translate }}</th>
                        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>{{ row[column.property] }}</td>
                    </ng-container>
                    <ng-container *ngIf="column.type === 'image'"  [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell
                            mat-sort-header> {{ column.label | translate }}</th>
                        <td *matCellDef="let row" mat-mini-fab mat-cell>
                            <mat-icon *ngIf="row.active" svgIcon="mat:check"></mat-icon>
                            <mat-icon *ngIf="!row.active" svgIcon="mat:clear"></mat-icon>
                        </td>
                    </ng-container>
                    <ng-container *ngIf="column.type === 'checkbox'"  [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell
                            mat-sort-header> {{ column.label | translate }}</th>
                        <td *matCellDef="let row" mat-mini-fab mat-cell>
                            <mat-icon *ngIf="row.force_comments" svgIcon="mat:check"></mat-icon>
                            <mat-icon *ngIf="!row.force_comments" svgIcon="mat:clear"></mat-icon>
                        </td>
                    </ng-container>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header></th>
                    <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
                        <button (click)="$event.stopPropagation()"
                                [matMenuTriggerData]="{ user: row }"
                                [matMenuTriggerFor]="actionsMenu"
                                mat-icon-button
                                type="button">
                            <mat-icon svgIcon="mat:more_horiz"></mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                <tr (click)="updateProject(row)"
                    *matRowDef="let row; columns: visibleColumns;"
                    @fadeInUp
                    [ngClass]="{'selected': isDeleted(row)}"
                    class="hover:bg-hover trans-ease-out cursor-pointer"
                    mat-row></tr>

            </table>

            <mat-paginator  [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"  (page)="pageChanged($event)"
                            class="sticky left-0"></mat-paginator>

        </div>

    </vex-page-layout-content>


</vex-page-layout>

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
    <ng-template let-user="user" matMenuContent>
        <button (click)="updateProject(user)" mat-menu-item>
            <mat-icon svgIcon="mat:edit"></mat-icon>
            <span>{{ "ACTIONS.EDITAR" | translate }}</span>
        </button>
        <button (click)="deleteProject(user)" mat-menu-item>
            <mat-icon svgIcon="mat:delete"></mat-icon>
            <span>{{ "ACTIONS.ELIMINAR" | translate }}</span>
        </button>
    </ng-template>
</mat-menu>
